import { Component, EventEmitter, Input, Output } from '@angular/core'

import {
  OpenRegistrationFilterOption,
  OpenRegistrationFilters,
} from '../open-registration-filter/open-registration-filter.component'

@Component({
  selector: 'se-po-open-registration-search',
  templateUrl: './open-registration-search.component.html',
  styleUrls: ['./open-registration-search.component.scss'],
  standalone: false,
})
export class OpenRegistrationSearchComponent {
  @Input() public sports: OpenRegistrationFilterOption[] = []
  @Input() public signupTypeList: OpenRegistrationFilterOption[] = []
  @Input() public organizations: OpenRegistrationFilterOption[] = []

  @Output() public searchTermChange = new EventEmitter<string>()
  @Output() public filtersChange = new EventEmitter<OpenRegistrationFilters>()

  public searchTerm = ''

  public handleSearchQueryChange(searchTerm: string): void {
    this.searchTerm = searchTerm
    this.searchTermChange.emit(searchTerm)
  }

  public handleFiltersChange(filters: OpenRegistrationFilters): void {
    this.filtersChange.emit(filters)
  }
}
